import { ComponentProps, FC, PropsWithChildren } from 'react';

import { Box, useToken } from '@bonusly/design-system';

interface UserSpotlightCardShellProps extends PropsWithChildren {
	/**
	 * Optional override for the inner "content" card padding (the solid surface).
	 */
	innerPadding?: ComponentProps<typeof Box>['p'];
}

export const UserSpotlightCardShell: FC<UserSpotlightCardShellProps> = ({ children, innerPadding = { base: 8, md: '60px' } }) => {
	const whiteAlpha500 = useToken('colors', 'whiteAlpha.500');

	return (
		<Box
			borderRadius="3xl"
			border="1.5px solid"
			borderColor="white"
			bg="whiteAlpha.700"
			boxShadow={`0 5.5px 30px 0 ${whiteAlpha500}`}
			backdropFilter="blur(9px)"
			p="15px"
			sx={{
				WebkitBackdropFilter: 'blur(9px)',
			}}
		>
			<Box bg="bg.surface" borderRadius="2xl" p={innerPadding} display="flex" flexDirection="column" justifyContent="center" position="relative">
				{children}
			</Box>
		</Box>
	);
};
